import * as style from './style.module.css';

const FormLayout = ({ children }) => <div className={style.form}>{children}</div>;

export default FormLayout;
